export let SOCIAL_SOURCES;
(function (SOCIAL_SOURCES) {
  SOCIAL_SOURCES["YOUTUBE"] = "youtube";
  SOCIAL_SOURCES["TWITTER"] = "twitter";
  SOCIAL_SOURCES["FACEBOOK"] = "facebook";
})(SOCIAL_SOURCES || (SOCIAL_SOURCES = {}));
//# sourceMappingURL=social-sources.js.map